import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Eye, EyeOff } from "lucide-react";
import { useAdminAuth } from "@/lib/adminAuth";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const [showPin, setShowPin] = useState(false);
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (login(pin)) {
      navigate("/admin/products");
    } else {
      setError(true);
      setShake(true);
      setPin("");
      setTimeout(() => setShake(false), 500);
    }
  }

  return (
    <div className="min-h-screen bg-stone-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-10">
          <span className="font-bold text-3xl tracking-[0.2em] text-white uppercase">
            Brupa
          </span>
          <p className="text-stone-500 text-xs tracking-widest uppercase mt-2">
            Admin Panel
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className={`bg-stone-900 p-8 ${shake ? "animate-bounce" : ""}`}
          style={shake ? { animation: "shake 0.4s ease" } : undefined}
        >
          <div className="flex items-center justify-center size-14 bg-stone-800 mx-auto mb-6">
            <Lock className="size-6 text-stone-400" />
          </div>

          <h1 className="text-white text-center text-sm tracking-widest uppercase mb-8 font-medium">
            Accesso riservato
          </h1>

          <div className="relative mb-6">
            <label className="block text-[10px] tracking-widest uppercase text-stone-500 mb-2">
              PIN di accesso
            </label>
            <div className="flex items-center border border-stone-700 bg-stone-800 focus-within:border-stone-400 transition-colors">
              <input
                autoFocus
                type={showPin ? "text" : "password"}
                value={pin}
                onChange={(e) => { setPin(e.target.value); setError(false); }}
                placeholder="••••"
                className="flex-1 bg-transparent px-4 py-3 text-white text-sm focus:outline-none placeholder-stone-600"
              />
              <button
                type="button"
                onClick={() => setShowPin(!showPin)}
                className="px-3 text-stone-500 hover:text-stone-300 transition-colors"
              >
                {showPin ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
              </button>
            </div>
            {error && (
              <p className="text-red-400 text-xs mt-2">PIN non corretto. Riprova.</p>
            )}
          </div>

          <button
            type="submit"
            disabled={!pin}
            className="w-full py-3.5 bg-white text-stone-900 text-xs tracking-widest uppercase font-semibold hover:bg-stone-100 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Accedi
          </button>
        </form>

        <p className="text-stone-600 text-xs text-center mt-6">
          PIN predefinito: <code className="text-stone-400">1234</code> — cambialo con <code className="text-stone-400">VITE_ADMIN_PIN</code>
        </p>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-8px); }
          80% { transform: translateX(8px); }
        }
      `}</style>
    </div>
  );
}
